import { api } from '../../services/api';
import * as types from '../Constants';
import { getCached, setCache, removeCache } from '../../Common/apiCache';

export const getPotentialClientStatus = (data) => {
  const cached = getCached('pcStatus');
  if (cached) {
    return (dispatch) =>
      Promise.resolve(dispatch({ type: types.POTENTIAL_CLIENT_STATUS_SUCCESS, payload: cached }));
  }
  const options = {
    url: 'v1/company/clientstatus/potentialclient/All',
  };
  options.types = [types.POTENTIAL_CLIENT_STATUS_SUCCESS, types.POTENTIAL_CLIENT_STATUS_FAILURE];
  const apiAction = api.get(options);
  return (dispatch) =>
    apiAction(dispatch).then((result) => {
      if (result && result.payload) setCache('pcStatus', result.payload);
      return result;
    });
};

export const addPotentialClientStatus = (data) => {
  removeCache('pcStatus');
  const options = {
    url: 'v1/company/clientstatus/potentialclient',
  };

  options.types = [
    types.ADD_POTENTIAL_CLIENT_STATUS_SUCCESS,
    types.ADD_POTENTIAL_CLIENT_STATUS_FAILURE,
  ];

  return api.post(options, data);
};

export const updPotentialClientStatus = (data) => {
  removeCache('pcStatus');
  const options = {
    url: 'v1/company/clientstatus',
  };

  options.types = [
    types.UPDATE_POTENTIAL_CLIENT_STATUS_SUCCESS,
    types.UPDATE_POTENTIAL_CLIENT_STATUS_FAILURE,
  ];

  return api.put(options, data);
};
